import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import sr from "./locales/sr.json";
import { getLanguageFromCookie } from "../cookies";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    sr: { translation: sr },
  },
  lng: getLanguageFromCookie(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export const resources = { en, es, sr } as const;

export default i18n;
